import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { appUiContent } from "@/app/content/uiContent";

export function RouteAnnouncer() {
  const { pathname } = useLocation();
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    const frameId = window.requestAnimationFrame(() => {
      const pageHeading = document.querySelector("main h1")?.textContent?.trim();
      const pageLabel = pageHeading || document.title;
      setAnnouncement(`${appUiContent.routeLoadedPrefix} ${pageLabel}`);
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [pathname]);

  return (
    <p className="sr-only" aria-live="polite" aria-atomic="true">
      {announcement}
    </p>
  );
}
